import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISH_CURATION_DATES_BY_CURATOR_QUERY } from '../graphql/queries'
import { FETCH_DISH_CURATION_DATES } from '../redux/action-types'

const useDishCurationDatesLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    curationDates: data,
    isCurationDatesLoading: isLoading,
    curationDatesError: error,
  } = useSelector(store => store.dishes.dishes)

  const fetch = useCallback(
    (menuId, curatorIds) =>
      apolloService.query({
        query: DISH_CURATION_DATES_BY_CURATOR_QUERY,
        variables: {
          menuId,
          curatorIds,
        },
        dispatch,
        action: FETCH_DISH_CURATION_DATES,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useDishCurationDatesLazyQuery
